import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid, LineChart, Line } from "recharts";

const Stat = ({label, value, sub}) => (
  <div className="bg-white border border-berulia-border p-6">
    <p className="overline text-berulia-inkmuted">{label}</p>
    <p className="font-heading text-3xl sm:text-4xl mt-2">{value}</p>
    {sub && <p className="text-xs text-berulia-inkmuted mt-1">{sub}</p>}
  </div>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then(r => setStats(r.data));
    api.get("/admin/analytics").then(r => setAnalytics(r.data)).catch(() => {});
  }, []);
  if (!stats) return <div className="p-4 sm:p-6 lg:p-10">Chargement…</div>;
  return (
    <div className="p-4 sm:p-6 lg:p-10">
      <p className="overline text-berulia-rosedeep">BERULIA · Back-office</p>
      <h1 className="font-heading text-3xl sm:text-4xl mt-2">Tableau de bord</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4 mt-8">
        <Stat label="Chiffre d'affaires" value={`${stats.revenue.toFixed(0)} €`} sub={`${stats.orders_count} commandes payées`}/>
        <Stat label="Commandes" value={stats.orders_count}/>
        <Stat label="Clientes" value={stats.customers_count}/>
        <Stat label="Produits actifs" value={stats.products_count}/>
        <Stat label="Visites totales" value={analytics ? analytics.total : "—"} sub="depuis la mise en ligne"/>
      </div>

      {analytics && analytics.daily && analytics.daily.length > 0 && (
        <div className="bg-white border border-berulia-border p-6 mt-8">
          <h2 className="font-heading text-2xl mb-4">Visites — 60 derniers jours</h2>
          <div className="h-56">
            <ResponsiveContainer>
              <LineChart data={analytics.daily}>
                <CartesianGrid stroke="#EAE3DB"/>
                <XAxis dataKey="date" stroke="#6F6660" tick={{fontSize: 11}}/>
                <YAxis stroke="#6F6660" allowDecimals={false}/>
                <Tooltip/>
                <Line type="monotone" dataKey="count" stroke="#D9A8B0" strokeWidth={2} dot={false}/>
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
      <div className="grid lg:grid-cols-3 gap-6 mt-8">
        <div className="bg-white border border-berulia-border p-6 lg:col-span-2">
          <h2 className="font-heading text-2xl mb-4">Revenu mensuel</h2>
          {stats.monthly_revenue.length === 0 ? <p className="text-berulia-inkmuted text-sm">Aucune donnée.</p> : (
            <div className="h-64">
              <ResponsiveContainer>
                <BarChart data={stats.monthly_revenue}>
                  <CartesianGrid stroke="#EAE3DB"/>
                  <XAxis dataKey="month" stroke="#6F6660"/>
                  <YAxis stroke="#6F6660"/>
                  <Tooltip/>
                  <Bar dataKey="revenue" fill="#D9A8B0"/>
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
        <div className="bg-white border border-berulia-border p-6">
          <h2 className="font-heading text-2xl mb-4">Top ventes</h2>
          {stats.top_products.length === 0 ? <p className="text-berulia-inkmuted text-sm">Pas encore de ventes.</p> : (
            <ul className="space-y-3">{stats.top_products.map((p,i)=>(<li key={i} className="flex justify-between text-sm"><span>{p.name}</span><span className="font-heading">{p.qty}</span></li>))}</ul>
          )}
        </div>
      </div>
    </div>
  );
}
